import {useContext} from 'react';
import {ThemeContext} from '../../utils/ThemeContext';

const ServicesHeroSvg1Mobile = () => {
  const {theme} = useContext(ThemeContext);
  const linearGradientID = theme === 'dark' ? 'url(#paint3)' : 'url(#paint4)';

  const svgContainerStyle = {
    position: 'absolute',
    left: 'calc(50% - 20px)',
    top: 'calc(50% - 295px)',
    width: '156',
    height: '50'
  };
  const pathStyle = {
    strokeDasharray: '1200',
    strokeDashoffset: '1200',
    animation: 'draw 2s ease-in-out forwards',
    animationDelay: '1s',
    stroke: linearGradientID,
    strokeWidth: '1',
    strokeLinecap: 'round'
  };

  return (
    <div style={svgContainerStyle}>
      <svg width='156' height='50' viewBox='0 0 156 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M155 49C119.477 20.8935 65.884 1.00001 1.02631 1.00001' style={pathStyle} />
        <defs>
          <linearGradient id='paint3' x1='49.0063' y1='-4.65778' x2='131.762' y2='85.3367' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#2463AC' />
            <stop offset='1' stopColor='#A3CDFF' stopOpacity='0' />
          </linearGradient>
          <linearGradient id='paint4' x1='49.0063' y1='-4.65778' x2='131.762' y2='85.3367' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#FE7518' />
            <stop offset='1' stopColor='#FE7518' stopOpacity='0' />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default ServicesHeroSvg1Mobile;

